import api from '@/api/app'
export default {
  namespaced: true,
  state: {
    user: null,
    message: 0
  },

  getters: {
    user: (state) => {
      return state.user
    }
  },
  mutations: {
    setUser(state, user) {
      localStorage.setItem('user', JSON.stringify(user))
      state.user = user
    },
    clearUser(state) {
      state.user = null
    },
    messageMutations(state, val) {
      state.message = val
    }
  },
  actions: {
    messageActions({ commit }) {
      api.notes.retrieve.messageNoNumber().then((res) => {
        commit('messageMutations', res.data.count)
      })
    }
  }
}
